module.exports = require('./convert')(
  ".exports=func\"'+,-/:;<>?EQW[]_bdghijklqvyz{}",
  "v.qlrpyo]ugbj_-}w[zSsWVZ>\"</={xeidchtn'kf;?+"
)
